import React from "react";
import Heading from "../../components/heading/heading";
import ProfileForm from "../../components/profile-form/profile-form";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

export function ProfileAddPage() {
    const { profile } = useSelector((state) => state.user);

    const hasCompleteProfile =
        !!profile && !!profile.interests?.length && !!profile.photos?.length;

    if (hasCompleteProfile) {
        return <Navigate to="/events" replace />;
    }

    return (
        <>
            <Heading tpl="new">Создай <span className="my-text-primary">профиль</span></Heading>
            <ProfileForm />
        </>
    );
}

